import './App.css';
import React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import AuthLayout from "./components/AuthLayout";
import MainLayout from './components/MainLayout';
import Login from './pages/auth/Login';
import Dashboard from './pages/dashboard/Dashboard';
import Profile from './pages/profiles/Profile';
import Tickets from './pages/tickets/Tickets';
import ListTickets from './pages/tickets/ListTickets';
import SeatMirrorDisplay from './pages/tickets/SeatMirrorDisplay';
import ListPackages from './pages/packages/ListPackages';
import Packages from './pages/packages/Packages';
import Branches from "./pages/branches/Branches";
import Company from './pages/company/Company';
import Roles from './pages/roles/Roles';
import Partners from './pages/partners/Partners';
import Drivers from './pages/drivers/Drivers';
import Users from './pages/users/Users';
import Destinations from './pages/destinations/Destinations';
import Schedules from './pages/schedules/Schedules';
import TypesUnits from './pages/typesunits/TypesUnits';
import Units from './pages/units/Units';
import Letters from './pages/letters/Letters';
import Trips from './pages/trips/Trips';
import AddTrips from './pages/trips/AddTrips';
import Binnacle from './pages/trips/Binnacle';
import Prices from './pages/prices/Prices';
import AddPrices from './pages/prices/AddPrices';
import CashCut from './pages/reports/CashCut';
import CashCutUser from './pages/reports/CashCutUser';
import EarningsReport from './pages/reports/EarningsReport';
import TransfersReport from './pages/reports/TransfersReport';
import CanceledTicketsReport from './pages/reports/CanceledTicketsReport';
import UpdatedTicketsReport from './pages/reports/UpdatedTicketsReport';
import DriverReport from './pages/reports/DriverReport';
import PageHome from './pages/admin/PageHome';
import PageAbout from './pages/admin/PageAbout';
import PageDestinations from './pages/admin/PageDestinations';
import PageServices from './pages/admin/PageServices';
import PageBlogs from './pages/admin/PageBlogs';
import PageContact from './pages/admin/PageContact';
import PageGallery from './pages/admin/PageGallery';
import Bills from './pages/bills/Bills';
import Permissions from './pages/permissions/Permissions';
import ListPermissions from './pages/permissions/ListPermissions';
import IdleWatcher from './IdleWatcher';
import BillsWay from './pages/BillsWay/BillsWay';
import Inventory from './pages/inventory/Inventory';
import RolTrabajo from './pages/trips/RolTrabajo';
import Kilometrages from './pages/kilometrages/Kilometrages';
import DailyEarningsReport from './pages/reports/DailyEarningsReport';
import BranchBinnacleReport from './pages/reports/BranchBinnacleReport';
import DriverBinnacle from './pages/driversection/Binnacledrivers';
import InsurancePolicies from './pages/document/InsurancePolicies';
import DriverDocuments from './pages/document/DriverDocuments';
import DiscountCodes from './pages/discountcodes/DiscountCodes';
import CashCutBranch from './pages/reports/CashCutBranch';


const isAuthenticated = () => {
    return localStorage.getItem("dataUser") !== null;
};

const PrivateRoute = ({ element }) => {
    return isAuthenticated() ? element : <Navigate to="/" />;
};

export default function App() {
    return (
        <div>
            <Router basename={"/admin"}>
                <Routes>
                    <Route path="/" element={<AuthLayout />}>
                        <Route path='/' element={<Login />} />
                    </Route>
                    <Route path="/seat-mirror-display" element={<PrivateRoute element={<SeatMirrorDisplay />} />} />
                    <Route path="/" element={<IdleWatcher><MainLayout /></IdleWatcher>}>
                        <Route path="/dashboard" element={<PrivateRoute element={<Dashboard />} />} />
                        <Route path="/perfil" element={<PrivateRoute element={<Profile />} />} />
                        <Route path="/agregar-boleto" element={<PrivateRoute element={<Tickets />} />} />
                        <Route path="/listado-paquetes" element={<PrivateRoute element={<ListPackages />} />} />
                        <Route path="/agregar-paquetes" element={<PrivateRoute element={<Packages />} />} />
                        <Route path="/listado-boletos" element={<PrivateRoute element={<ListTickets />} />} />
                        <Route path="/empresa" element={<PrivateRoute element={<Company />} />} />
                        <Route path="/sucursales" element={<PrivateRoute element={<Branches />} />} />
                        <Route path="/roles" element={<PrivateRoute element={<Roles />} />} />
                        <Route path="/socios" element={<PrivateRoute element={<Partners />} />} />
                        <Route path="/conductores" element={<PrivateRoute element={<Drivers />} />} />
                        <Route path="/usuarios" element={<PrivateRoute element={<Users />} />} />
                        <Route path="/destinos" element={<PrivateRoute element={<Destinations />} />} />
                        <Route path="/horarios" element={<PrivateRoute element={<Schedules />} />} />
                        <Route path="/tipos-unidades" element={<PrivateRoute element={<TypesUnits />} />} />
                        <Route path="/unidades" element={<PrivateRoute element={<Units />} />} />
                        <Route path="/letras" element={<PrivateRoute element={<Letters />} />} />
                        <Route path="/viajes" element={<PrivateRoute element={<Trips />} />} />
                        <Route path="/agregar-viajes" element={<PrivateRoute element={<AddTrips />} />} />
                        <Route path="/bitacora" element={<PrivateRoute element={<Binnacle />} />} />
                        <Route path="/precios" element={<PrivateRoute element={<Prices />} />} />
                        <Route path="/gastos-unidad" element={<PrivateRoute element={<Bills />} />} />
                        <Route path="/ingresos-camino" element={<PrivateRoute element={<BillsWay />} />} />
                        <Route path="/agregar-precios" element={<PrivateRoute element={<AddPrices />} />} />
                        <Route path="/corte-caja" element={<PrivateRoute element={<CashCut />} />} />
                        <Route path="/corte-caja-usuario" element={<PrivateRoute element={<CashCutUser />} />} />
                        <Route path="/reporte-ganancias" element={<PrivateRoute element={<EarningsReport />} />} />
                        <Route path="/reporte-transferencias" element={<PrivateRoute element={<TransfersReport />} />} />
                        <Route path="/reporte-cancelaciones" element={<PrivateRoute element={<CanceledTicketsReport />} />} />
                        <Route path="/reporte-actualizaciones" element={<PrivateRoute element={<UpdatedTicketsReport />} />} />
                        <Route path="/reporte-conductores" element={<PrivateRoute element={<DriverReport />} />} />
                        <Route path="/page-home" element={<PrivateRoute element={<PageHome />} />} />
                        <Route path="/page-nosotros" element={<PrivateRoute element={<PageAbout />} />} />
                        <Route path="/page-destinos" element={<PrivateRoute element={<PageDestinations />} />} />
                        <Route path="/page-servicios" element={<PrivateRoute element={<PageServices />} />} />
                        <Route path="/page-blogs" element={<PrivateRoute element={<PageBlogs />} />} />
                        <Route path="/page-contacto" element={<PrivateRoute element={<PageContact />} />} />
                        <Route path="/page-galeria" element={<PrivateRoute element={<PageGallery />} />} />
                        <Route path="/permisos" element={<PrivateRoute element={<Permissions />} />} />
                        <Route path="/permisos/:roleId" element={<PrivateRoute element={<Permissions />} />} />
                        <Route path="/listado-permisos" element={<PrivateRoute element={<ListPermissions />} />} />
                        <Route path="/inventario" element={<PrivateRoute element={<Inventory />} />} />
                        <Route path="/rol-trabajo" element={<PrivateRoute element={<RolTrabajo />} />} />
                        <Route path="/Kilometrages" element={<PrivateRoute element={<Kilometrages />} />} />
                        <Route path="/socio-reporte" element={<DailyEarningsReport />} />
                        <Route path="/reporte-bitacoras" element={<BranchBinnacleReport />} />
                        <Route path="/mi-corrida" element={<DriverBinnacle />} />
                        <Route path="/polizas-seguro" element={<InsurancePolicies />} />
                        <Route path="/document-drivers" element={<DriverDocuments />} />
                        <Route path="/codigos-descuento" element={<PrivateRoute element={<DiscountCodes />} />} />
                        <Route path="/corte-caja-taquilla" element={<PrivateRoute element={<CashCutBranch />} />} />
                    </Route>
                </Routes>
            </Router>
        </div>
    );
}